import Navbar from '../../components/Navbar';
import KnowPlans from '../../components/KnowPlans';
import Footer from '../../components/Footer';
import BePartOfIt from '../../components/BePartOfIt';
import FormBuy from '../../components/FormBuy';

export default function Part() {
  return (
    <>
      <Navbar />
      <BePartOfIt />
      <KnowPlans />
      <FormBuy />
      <Footer />
    </>
  );
}
